import { Component, OnInit, Input, NgZone } from '@angular/core';
import { CommService } from "../../../comm.service";
import {NgForm} from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
//import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-reklamaceNahled',
  templateUrl: './analyzaZmetkovostiNahled.component.html',
  styleUrls: ['./../../../app.component.css']
})

export class AnalyzaZmetkovostiNahledComponent implements OnInit {
  private chart: am4charts.XYChart;
  constructor(private comm: CommService, private router:Router, private zone: NgZone) { }

nadpis1="Analýza zmetkovitosti";
options: any;
data=[];
typyVyrobku: any[] = [];
chartData=[{"pn": "", "total":null, "totalNOK":null}];
export=[{"pn": "", "typVyrobku": "", "total":null, "totalNOK":null, "totalOK":null, "chyby":""}];
today=new Date();
  lastmonth=new Date(new Date().setDate(new Date().getDate()-30));
  dayafter=new DatePipe('en-US').transform(this.today, 'yyyy-MM-dd 23:59:59.993');
  dayback=new DatePipe('en-US').transform(this.lastmonth, 'yyyy-MM-dd');
  datum={"od":"", "do":"", "doSQL":"", "typVyroby":null};

  ngOnInit() {
    console.log(this.comm.typVyrobyIdent);
    console.log(this.dayafter);
    console.log(this.dayback);
    this.datum.od=this.dayback;
    this.datum.do=this.dayafter;
    this.datum.doSQL=this.dayafter;
    this.datum.typVyroby=this.comm.typVyrobyIdent;
    console.log(this.datum.doSQL);
    this.getanalyzazavad();
    this.getanalyzazavadchart();

    this.comm.typyVyrobku().index().subscribe(
    (res) => {
      this.typyVyrobku = res.json();
      console.log('Typy výrobků:', this.typyVyrobku);

      // až potom načti analyzu
      this.getanalyzazavad();
    },
    (err) => console.log(err)
  );

  }

  getAuthUser() {
    return this.comm.getAuthUser()
}

  amChart() {
    this.zone.runOutsideAngular(() => {

      // Create chart instance
let chart = am4core.create("chartdiv", am4charts.XYChart);

// Add data
chart.data = this.chartData;
console.log(chart.data);
console.log("teď");
// Create axes
let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.title.text = "Produkty";
categoryAxis.dataFields.category = "pn";
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.renderer.minGridDistance = 30;

let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
valueAxis.title.text = "Počet NOK";

// Create series
let series = chart.series.push(new am4charts.ColumnSeries());
series.dataFields.valueY = "totalNOK";
series.dataFields.categoryX = "pn";
series.name = "Počet NOK";
series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
series.columns.template.fillOpacity = .8;

let columnTemplate = series.columns.template;
columnTemplate.strokeWidth = 2;
columnTemplate.strokeOpacity = 1;

chart.exporting.menu = new am4core.ExportMenu();
this.chart = chart;
    });
  }

  getanalyzazavad(){
    this.comm.getAnalyzaZavadFiltr(this.datum).subscribe(
      //(response) => console.log(response),
      (response) => {
        const rawData = response.json();

      // nahrazení číselného typVyrobku názvem přímo v data
      this.data = rawData.map(item => {
        const typ = this.typyVyrobku.find(t => t.id === item.typVyrobku);
        return {
          ...item,
          typVyrobku: typ ? typ.name : 'Neznámý typ'
        };
      });

      this.export = this.data.map(({ image, ...rest }) => ({
        ...rest,
        chyby: rest.chyby
          ? rest.chyby
              .replace(/[:;\.\-]/g, '')   // odstraní čárky, dvojtečky, středníky, tečky, pomlčky
              .replace(/\s+/g, ' ')        // zredukuje vícenásobné mezery
              .trim()                      // odstraní mezery na začátku/konci
          : ''
      }));

        console.log(this.data);
        console.log(this.export);
      },
      (error) => console.log(error));
      return this.data;
  }

  getanalyzazavadchart(){
    this.comm.getAnalyzaZavadChart(this.datum).subscribe(
      //(response) => console.log(response),
      (response) => {
        this.chartData=response.json();
        console.log(this.chartData);
        console.log("teď");
        this.amChart();
      },
      (error) => console.log(error));
      return this.chartData;
  }


  onSubmit(form:NgForm){
    if (form.value.od!=''){this.datum.od=form.value.od};
    if (form.value.do!=''){this.datum.do=form.value.do};
    console.log(this.datum.od);
    this.datum.doSQL=this.datum.do+" 23:59:59.993";
    console.log(this.datum.doSQL);
    this.comm.getAnalyzaZavadFiltr(this.datum).subscribe(
      //(response) => console.log(response),
      (response) => {
        this.data=response.json();
        console.log(this.data);
        this.getanalyzazavadchart();
      },
      (error) => console.log(error));
      return this.data;
  }

  dejdata(){
    this.comm.products().index().subscribe(
      (response) => console.log(response),
      (error) => console.log(error));
  }

download(){
    var csvData = this.ConvertToCSV(this.export);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    const BOM = '\uFEFF';
    const blob = new Blob([BOM, csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    a.href = url;
    a.download = 'Data.csv';
    a.click();
}

  ConvertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) {
        //Now convert each value to string and comma-separated
        row += index + ';';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'

            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
}

}
